import { ArticleResolution } from '@wix/answers-api';
import { Tag, Text, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import Long from 'long';
import React, { FunctionComponent } from 'react';

import { DATA_HOOKS } from '../../dataHooks';
import { useResponsive } from '../../hooks/useResponsive';
import { getQuarter } from '../../utils/roadmap';
import { RoadmapResolutionBadge } from '../RoadmapResolutionBadge';

import css from './index.module.scss';

type RoadmapResolutionEtaProps = {
  wrapEtaWithTag?: boolean;
  resolution?: ArticleResolution;
  resolutionEta?: Long | number;
  onClickStatus?: (articleResolution: ArticleResolution) => void;
};

export const RoadmapResolutionEta: FunctionComponent<
  RoadmapResolutionEtaProps
> = ({ resolution, resolutionEta, onClickStatus, wrapEtaWithTag }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  const renderEta = (eta: Long | number) => {
    const { quarter, year } = getQuarter(eta); // ?
    return (
      <Text
        dataHook={DATA_HOOKS.ARTICLE_ITEM_ETA}
        size={isMobile ? 'tiny' : 'small'}
        weight="thin"
        className={css.eta}
      >
        {t('roadmap.article-item.eta', { quarter, year })}
      </Text>
    );
  };

  return (
    <div className={`${css.roadmapResolutionEta} ${onClickStatus ? 'clickable' : ''}`}>
      {resolution && (
        <RoadmapResolutionBadge
          resolution={resolution}
          size="small"
          resolutionEta={resolutionEta}
          onClickStatus={onClickStatus}
        />
      )}
      {resolutionEta &&
        resolution !== ArticleResolution.RELEASED &&
        <Text className={css.spacingDot}>·</Text>}
      {resolutionEta && resolution !== ArticleResolution.RELEASED && (
        <Tooltip
          size="small"
          disabled={!onClickStatus}
          content={t(`roadmap.article-list.resolution.tooltip.eta.${getQuarter(resolutionEta).quarter}`,
            { year: `${getQuarter(resolutionEta).year}` }
          )}
        >
          {!wrapEtaWithTag || isMobile ? (
            renderEta(resolutionEta)
          ) : (
            <Tag
              size="small"
              className={`${css.etaTag}`}
              id={'eta'}
              theme="standard"
              removable={false}
            >
              <div className={`${css.etaBody}`}>{renderEta(resolutionEta)}</div>
            </Tag>
          )}
        </Tooltip>
      )}
    </div>
  );
};
